<div class="dialog-container" >
    <div class="header">
        <p class="white inline-block"><b>{{dialogData.title}}</b></p>
    </div>
    <div class="content">
        <p display-2>{{dialogData.message}}</p>
        <div class="confirm-buttons uk-text-center margin-top-20">
            <button class=" uk-button uk-button-thin uk-button-primary yes" (click)="onConfirm()">Okay</button>
        </div>
    </div>
</div>
